import React from 'react'
import { ButtonGroup, Button } from 'react-bootstrap'
import USER_ROLES from '../../../constants/user-roles'
import currentGradYear from '../../../utilities/current-grad-year'
import useUsersFilter from '../../../hooks/use-users-filters'

const FilterButton = ({ onClick = () => {}, active, children }) => (
    <Button variant={active ? undefined : 'outline-primary'} onClick={onClick}>{children}</Button>
)

const UsersRoleFilter = () => {
    const {
        rolesCode,
        updateFilters
    } = useUsersFilter()
    const role = rolesCode
    const onRoleClicked = (role) => {
        if (role === USER_ROLES.STUDENT) {
            updateFilters({ rolesCode: role, gradYearMinimum: currentGradYear, gradYearMaximum: currentGradYear + 4, offset: 0})
        } else {
            updateFilters({ rolesCode: role, gradYearMinimum: null, gradYearMaximum: null, offset: 0})
        }
        
    }
    return (
        <React.Fragment>
            <ButtonGroup size='lg'>
                <FilterButton active={role === USER_ROLES.STUDENT} onClick={() => onRoleClicked(USER_ROLES.STUDENT)}>STUDENTS</FilterButton>
                <FilterButton active={role === USER_ROLES.TSC} onClick={() => onRoleClicked(USER_ROLES.TSC)}>TSC</FilterButton>
                <FilterButton active={role === USER_ROLES.FACILITATOR} onClick={() => onRoleClicked(USER_ROLES.FACILITATOR)}>FACILITATORS</FilterButton>
                <FilterButton active={role === USER_ROLES.ADMIN} onClick={() => onRoleClicked(USER_ROLES.ADMIN)}>ADMINISTRATORS</FilterButton>
                <FilterButton active={!role} onClick={() => onRoleClicked('')}>ALL</FilterButton>
            </ButtonGroup>
        </React.Fragment>
    )
}

export default UsersRoleFilter